/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/inviteUser.config.json";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { CREATE_USERS } from "../graphql";
import { VApplication } from "../../../application";
import notification from "../config/notifications.config.json";
import axios from "axios";
import { LoggerModule } from "@vlinder-web/logger-module-react";

const log: any = LoggerModule?.getInstance();
const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface InviteUserProps {
  email: string;
  firstName?: string;
  lastName?: string;
  invite?: boolean;
  role?: string;
  phone?: string;
}
export interface IInviteUserMethods extends IPluginMethodMap {
  getInviteUser(args: InviteUserProps): Promise<any>;
}

export class InviteUserService implements IAgentPlugin {
  readonly methods: IInviteUserMethods;

  constructor() {
    this.methods = {
      getInviteUser: this.getInviteUser.bind(this),
    };
  }

  async getInviteUser(args: InviteUserProps) {
    console.log(`inviteUser server component:`, args);
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    const isInvite = this.checkRole(args?.role);
    try {
      if (client) {
        const res = await client.mutate({
          mutation: CREATE_USERS,
          variables: {
            input: {
              invite: isInvite,
              role: args?.role,
              user: {
                email: args?.email,
                firstName: args?.firstName,
                lastName: args?.lastName,
                primaryContactNo: args?.phone,
                phones: [
                  {
                    number: args?.phone,
                  },
                ],
              },
            },
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          return {
            ...res?.data?.createUser,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }

  private checkRole(roleId: string) {
    console.log("roleId94", roleId)
    const roleArray = [
      {
        label: "Masquerader",
        id: "fe93dab0-424b-4aa3-9efa-c001b4c04444",
      },
      {
        label: "Admin",
        id: "fe93dab0-424b-4aa3-9efa-c001b4c03013",
      },
      {
        label: "committeeMember",
        id: "99403c8b-abc1-4796-b61f-78e0c4022792",
      },
      {
        label: "cashier",
        id: "f5bebfee-dc0a-460a-9a3f-c6cde8fed944",
      },
      {
        label: "supervisor",
        id: "ca9521c7-d584-43b8-8c90-79aa3e11bddc",
      },
      {
        label: "cashSupervisor",
        id: "5dbff659-66e4-4a66-b03c-f9b2d3dd6de6",
      },
    ];
    const matchedRole = roleArray.find((r) => r.id === roleId);
    console.log("roleId122", matchedRole)

    if (
      matchedRole &&
      (matchedRole.label === "Admin" ||
        matchedRole.label === "committeeMember" ||
        matchedRole.label === "cashier" ||
        matchedRole.label === 'supervisor' ||
        matchedRole.label === 'cashSupervisor'
      )
    ) {
      return true;
    }
    return false;
  }
}
